<template>
  <div class="upload">
    <van-form class="form" @submit="onSubmit">
      <van-field
        v-model="titleName"
        required
        label="材料名称"
        placeholder="请输入材料名称"
        clearable
        :rules="[{ required: true, message: '请填写材料名称' }]"
      />
      <van-field name="uploader" label="材料附件" required>
        <template #input>
          <van-uploader
            v-model="uploader" 
            :after-read="onAfterRead"
            :before-read="onBeforeRead"
            accept=""/>
        </template>
      </van-field>
      <div class="btn-group">
        <van-button class="btn" type="info" color="#ccc" @click.stop="goBack">取消</van-button>
        <van-button class="btn" type="info" native-type="submit">上传</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import api from '@/utils/api/personCenter'
import moduleMixins from '@/mixins/moduleMixins'
export default {
  components: {},
  mixins: [ moduleMixins ],
  props: {},
  data() {
    return {
      fromData: {},
      // uploader: [{ url: 'https://img01.yzcdn.cn/vant/leaf.jpg' }],
      uploader: [],
      fileList:[],// 附件数组
      fileListUrl:[],// 附件文件服务器路径数组
      list:[],// 上传附件数组
      accept:".png,.jpg,.jpeg,.pdf,.doc,.docx,.xls,.xlsx,.txt,.zip,.rar,.gif",// 允许上传类型
      userInfo:{},// 用户信息
      
      fileName:'',// 文件名
      titleName:"",// 文件名（去除.）
      fileUrl:"",// 文件完整路径
      rid:"",//

    };
  },
  watch: {},
  computed: {
    navTitle() {
      return '上传材料'
    }
  },
  methods: {
    onSubmit() {
      let params = {}
      params.FILENAME = this.fileName;
      params.FILEURL = this.fileUrl
      params.RID = this.rid
      params.CLMC = this.titleName

      api
        .addMaterialLibrary(params)
        .then(res => {
          console.log("addMaterialLibrary res:",res);
          this.$toast.success("新增成功")
          setTimeout(()=>{
            this.$router.go(-1)
          },1000)
        })
        .catch(err => {
          console.log("err:",err.response);
          this.$toast.fail('新增失败')
        })
    },
    onAfterRead(file) {
      // 此时可以自行将文件上传至服务器
      if (!(file instanceof Array)) {
        this.upload(file)
      } else {
        file.forEach(item => {
          this.upload(item)
        })
      }
      this.$emit('onAfterRead', file)
    },
    // 文件读取前的回调函数
    onBeforeRead(file) {
      console.log(file)
      // 黑名单文件判断(固定9种类型)
      if (/.(jsp|jspx|jspf|sh|html|htm|shtml|js|htaccess)$/i.test(file.name)) {
        this.$toast('文件类型不支持')
        return false
      }
      // 文件类型判断(由后台配置传入)
      if (this.accept && this.accept != '*') {
        const nameArr = file.name.split('.')
        const type = '.' + nameArr[nameArr.length - 1]
        if (!this.accept.includes(type)) {
          this.$toast('文件类型不匹配')
          return false
        }
      }

      this.fileName = file.name// 附件名称
      this.titleName = this.getTitleName(file)// CLMC材料名称（可手动编辑）
      this.$emit('onBeforeRead', file)
      return true
    },
    upload(file) {
      const params = new FormData()
      console.log('file', file)
      params.append('file', file.file)
      api
        .materialUpload(params)
        .then(res => {
          console.log("upload res:",res);
          if(res.code == 0){
            this.fileList.push(res.data[0])
            let data = res.data
            if(data.length > 0){
              for(let i = 0; i < data.length; i++){
                // console.log('data[i]:',data[i]);
                // this.fileName = data[i].fileName// 附件名称
                // this.titleName = this.getTitleName(data[i].fileName)// CLMC材料名称（可手动编辑）
                this.fileUrl = data[i].fileUrl// 附件上传后的文件服务器路径
                this.fileListUrl.push(data[i].fileUrl)
                // console.log("this.fileListUrl[i]:",this.fileListUrl[i]);
              }
            }
            // console.log("this.fileListUrl:",this.fileListUrl);
            this.$toast.success("材料上传成功")
          }
        })
        .catch(err => {
          console.log("err:",err.response);
          // this.$toast.fail('材料上传失败')
        })
    },
    // 获取文件名
    getTitleName(file){
      return file.name.substring(0, file.name.lastIndexOf("."));
    },
    // 计算文件大小
    getSize(fileSize) {
      let size = ''
      if (fileSize < 0.1 * 1024) {
        // 小于0.1KB，则转化成B
        size = fileSize.toFixed(2) + 'B'
      } else if (fileSize < 0.1 * 1024 * 1024) {
        // 小于0.1MB，则转化成KB
        size = (fileSize / 1024).toFixed(2) + 'KB'
      } else if (fileSize < 0.1 * 1024 * 1024 * 1024) {
        // 小于0.1GB，则转化成MB
        size = (fileSize / (1024 * 1024)).toFixed(2) + 'MB'
      } else {
        // 其他转化成GB
        size = (fileSize / (1024 * 1024 * 1024)).toFixed(2) + 'GB'
      }

      const sizeStr = size + '' // 转成字符串
      const index = sizeStr.indexOf('.') // 获取小数点处的索引
      const dou = sizeStr.substr(index + 1, 2) // 获取小数点后两位的值
      if (dou == '00') {
        // 判断后两位是否为00，如果是则删除00
        return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2)
      }
      return size
    },
    // 返回
    goBack(){
      this.$router.go(-1)
    },
  },
  created() {},
  mounted() {}
};
</script>
<style lang="scss" scoped>
.upload{
  background-color: #fff;
  .form {
    padding: 20px;
    background-color: #fff;
    .van-cell {
      display: block;
      ::v-deep .van-field__label {
        width: 100%;
        padding-bottom: 5px;
      }
    }
    .btn-group {
      margin-top: 30px;
      text-align: center;
      .btn {
        width: 150px;
        border-radius: 5px;
        &:first-child {
          margin-right: 10px;
        }
      }
    }
  }
}
</style>